/**
 * File: /Users/tomasmuniesa/Documents/develop/nousmedis/nm-apps/3_catalog_cloud/develop/frontend/src/app/modules/user/services/lang.service.ts
 * Project: /Users/tomasmuniesa/Documents/develop/nousmedis/nm-apps/3_catalog_cloud/develop/frontend
 * Created Date: Friday, January 10th 2025, 1:29:22 pm
 * Author: Tomás
 * -----
 * Last Modified:  Thursday, 15th May 2025 10:28:55 am
 * Modified By: Tomás (tomas@cege.es>)
 * -----
 * Copyright (c) 2025 Nousmedis, CeGe
 * ------------------------------------
 */

import { Injectable } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { langs } from "assets/i18n/available-lang";

@Injectable({
    providedIn: "root",
})
export class LangService {

    constructor (private translate: TranslateService,
    ) {
        translate.addLangs(
            langs.map((l) => {
                return l.value;
            })
        );
    }

    initLangSite(user: any) {
        if (user === undefined) {
            this.setLang("default", "es_ES");
            this.translate.setDefaultLang("es_ES");
        }

        if (user && user.id) {
            if (this.getLang(user.id) === undefined) {
                this.setLang(user.id, "es_ES");
            }
            const lang = this.getLang(user.id);
            this.translate.setDefaultLang(lang);
        }

    }

    getLang(idUSer: string) {

        if (!localStorage.getItem('nm-lang-' + idUSer)) {
            return 'es_ES';
        }

        if (localStorage.getItem('nm-lang-' + idUSer) === null) {
            return 'es_ES';
        }
        else {
            return localStorage.getItem('nm-lang-' + idUSer);
        }
    }

    setLang(idUSer: string, lang: string) {
        localStorage.setItem('nm-lang-' + idUSer, lang);
    }



}